<template>
  <b-dropdown
    id="actions-dropdown"
    :disabled="disabled"
    toggle-tag="div"
    toggle-class="p-0 bg-transparent"
    hide-on-click-out
    @hide="onDropdownHide"
  >
    <template #button-content>
      <McButton
        variant="secondary"
        icon="icon-outline_chevron-down"
        icon-position="right"
        :text="$t('fleetTaskInstant.action.button')"
        :disabled="disabled"
      />
    </template>

    <b-dropdown-item class="multilevel-dropdown" @click="handleAction(() => {}, false)">
      <div class="d-flex justify-content-between align-items-center">
        <span>{{ $t('global.action.changeStatus') }}</span>
        <i class="icon-outline_chevron-right"></i>
      </div>
      <!-- Invisible box to fill gap between dropdown and child dropdown. If this doesn't exist, the child dropdown disappear when user
       move their cursor to child dropdown -->
      <div class="gap-filler"></div>
      <div class="multilevel-dropdown-menu pr-2">
        <div class="dropdown-menu">
          <b-dropdown-item @click="handleAction(() => actionHandlers.handleTransitionTo(statusItems[status.DRAFT].key))">
            {{ $t('salesOrder.status.draft') }}
          </b-dropdown-item>
          <b-dropdown-item @click="handleAction(() => actionHandlers.handleTransitionTo(statusItems[status.CONFIRMED].key))">
            {{ $t('salesOrder.status.confirmed') }}
          </b-dropdown-item>
          <b-dropdown-item @click="handleAction(() => actionHandlers.handleTransitionTo(statusItems[status.ASSIGNED].key))">
            {{ $t('salesOrder.status.assigned') }}
          </b-dropdown-item>
          <b-dropdown-item @click="handleAction(() => actionHandlers.handleTransitionTo(statusItems[status.COMPLETED].key))">
            {{ $t('salesOrder.status.completed') }}
          </b-dropdown-item>
          <b-dropdown-item
            class="red-text"
            @click="handleAction(actionHandlers.handleTransitionToCanceled)"
          >
            {{ $t('salesOrder.status.canceled') }}
          </b-dropdown-item>
        </div>
      </div>
    </b-dropdown-item>

    <b-dropdown-item class="red-text" @click="handleAction(actionHandlers.handleDelete)">
      {{ $t('global.delete') }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import McButton from '@/components/McButton'
import statuses, { status } from '../../lib/constants/status'

export default {
  components: {
    McButton,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    actionHandlers: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      status,
      okToHide: true,
    }
  },
  computed: {
    statusItems() {
      return statuses(this)
    },
  },
  methods: {
    handleAction(handler, shouldClose = true) {
      handler()
      if (!shouldClose) {
        this.okToHide = false
      }
    },
    onDropdownHide(bvEvent) {
      if (!this.okToHide) {
        bvEvent.preventDefault()
        this.okToHide = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>
